import { useRef, useState, useEffect } from 'react';
//import { Storage } from 'aws-amplify';
import { GetClienteContactos, GetClientes, GetClientesID, GetCotizaciones } from '../components/queries/Queries';
import { actualizarClientes, guardarCliente } from '../components/queries/Mutations';
import { getUrl, list } from "@aws-amplify/storage";
//import ImageUploader from 'react-images-upload';

//Variables que almacenan los datos del cliente
const initialFormState = {
    cliente: '', activo: true, descripcion: '', domicilio: '', colonia: '',
    ciudad: '', estado: '', pais: '', codigoPostal: '', telefono: '', correo: '',
    rfc: '', razonSocial: '', usoCFDI: '', billTo: '', shipTo: '',
    facturaTipo: 'Invoice', requiereIVA: false, porcentajeIVA: '8 %',
    nombreContacto: '', puestoContacto: '', telefonoContacto: '', correoContacto: '',
    nombreContacto1: '', puestoContacto1: '', telefonoContacto1: '', correoContacto1: '',
    nombreContacto2: '', puestoContacto2: '', telefonoContacto2: '', correoContacto2: '',
    nombreContacto3: '', puestoContacto3: '', telefonoContacto3: '', correoContacto3: '',
    nombreContacto4: '', puestoContacto4: '', telefonoContacto4: '', correoContacto4: '',
    Reg_Ins_Usuario: '', Reg_Mod_Usuario: ''
}

const initialfFormState = { formType: 'Catálogo' }
export default function useClientes() {

    //Declaración de variables
    const [clientes, setClientes] = useState([]);
    const [contactosClientes, setContactosClientes] = useState([]);
    const [clientesCotizacion, setClientesCotizacion] = useState([]);
    const [mClientes, setMClientes] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [formData, updateFormData] = useState(initialFormState);
    const [estadoCliente, setEstadoCliente] = useState("todos");
    const [isDisabled, setisDisabled] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [guardarDisable, setGuardarDisabled] = useState(false);
    const [contacto, setContacto] = useState(1);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pclientes = window.$Clientes ? window.$Clientes : false;
    const [aVisible, setAVisible] = useState(false);
    const [imagenRepetida, setImagenRepetida] = useState(true);
    const [imagen, setImagen] = useState([]);
    const [editarImagen, setEditarImagen] = useState(false);
    const inputElement = useRef(null);
    const onDismiss = () => setAVisible(false);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    //Método useEffect
    useEffect(() => {
        fetchClientes();
        //if (inputElement.current) {
        // inputElement.current.React.focus();
        // }      
    }, []);
    //Guarda la imagen seleccionada
    async function onChangeimage(e) {
        /*setMensajeAlert("Revisando si la imagen ya existe");
        setColor("primary");*/
        setAVisible(false);
        setCargando(true);
        window.scrollTo(0, 0);
        setImagenRepetida(true);
        setGuardarDisabled(true);
        if (!e.target.files[0]) {
            setImagenRepetida(false);
            setGuardarDisabled(false);
            setCargando(false);
            return
        }
        const file = e.target.files[0];
        const imageexist = await list({ path: "public/" + file.name });
        if (imageexist.items.length === 0) {
            setImagenRepetida(false);
            setGuardarDisabled(false);
            setCargando(false);
            setEditarImagen(true);
            setImagen(file);
            updateFormData({ ...formData, image: file.name });
        } else {
            setImagenRepetida(true);
            setMensajeAlert("Ya existe una imagen con el mismo nombre: favor de seleccionar otra imagen o cambiar el nombre de la imagen y volver a intentarlo.");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            window.scrollTo(0, 0);
        }
    }
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        //const apiData = await API.graphql({ query: listClientes, limit: 100000000 });
        setAVisible(false);
        setCargando(true);

        const apiData = await GetClientes();
        const clientesFromAPI = apiData;
        await Promise.all(clientesFromAPI.map(async cliente => {
            if (cliente.image) {
                const image = await getUrl({ key: cliente.image });// await Storage.get(cliente.image);
                cliente.imagename = cliente.image;
                cliente.image = image.url.toString();
            }
            return cliente;
        }))
        setClientes(apiData);
        setCargando(false);
    }
    //Obtiene los datos guardados de los clientes de la cotización.
    async function fetchClientesCotizacion() {
        setAVisible(false);
        setCargando(true);
        let filter = {
            and: [{
                clienteCatalogo: {
                    eq: false
                }
            },
            {
                activo: {
                    eq: true
                }
            },
            {
                status: {
                    eq: "Accepted"
                }
            }
            ]
        };

        const apiData = await GetCotizaciones(filter);
        setClientesCotizacion(apiData);
        setCargando(false);
    }

    //Revisa cambios en los inputs
    function onChanges(e) {
        e.persist()
        updateFormData(() => ({ ...formData, [e.target.name]: e.target.value }));

    }
    //Revisa cambios en los inputs
    function seleccionarCliente(cliente, i, lista) {
        updateFormData(() => ({
            ...formData, cliente: cliente.cliente, domicilio: cliente.address, ciudad: cliente.ciudad, codigoPostal: cliente.codigoPostal,
            colonia: cliente.colonia, estado: cliente.estado, pais: cliente.pais, correo: cliente.correo,
            telefono: cliente.telefono, nombreContacto: cliente.requestor, puestoContacto: cliente.position,
            telefonoContacto: cliente.desk + ", " + cliente.mobile, correoContacto: cliente.email, idCotizacion: cliente.id
        }));
        lista[i].seleccionado = true;
        toggle();
        return lista;
    }
    //Obtiene el estado seleccionado en el combo de mostrando clientea
    function sClienteEstado(e) {
        e.persist()
        setEstadoCliente(e.target.value);
        setCargando(false);
        setAVisible(false);
    }

    //Prepara los datos del cliente para mostrarlos
    async function onClickCliente(cliente) {
        //Se revisa si hay concurrencia.
        const clienteID = await obtenerClienteporID(cliente.id);
        setCargando(false);
        setAVisible(false);
        updateFormData(clienteID);
        setMClientes(clienteID);
    }

    async function obtenerClienteporID(id) {
        setCargando(true);
        const clientesFromAPI = await GetClientesID(id);
        if (clientesFromAPI.id) {
            if (clientesFromAPI.image) {
                const image = await getUrl({ key: clientesFromAPI.image });//await Storage.get(clientesFromAPI.image);
                clientesFromAPI.imagename = clientesFromAPI.image;
                clientesFromAPI.image = image.url.toString();
            }
        }
        var contactosCliente = [];
        contactosCliente.push({
            nombreContacto: clientesFromAPI.nombreContacto,
            puestoContacto: clientesFromAPI.puestoContacto,
            telefonoContacto: clientesFromAPI.telefonoContacto,
            correoContacto: clientesFromAPI.correoContacto
        })
        if (clientesFromAPI.nombreContacto1) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto1,
                puestoContacto: clientesFromAPI.puestoContacto1,
                telefonoContacto: clientesFromAPI.telefonoContacto1,
                correoContacto: clientesFromAPI.correoContacto1
            })
        }
        if (clientesFromAPI.nombreContacto2) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto2,
                puestoContacto: clientesFromAPI.puestoContacto2,
                telefonoContacto: clientesFromAPI.telefonoContacto2,
                correoContacto: clientesFromAPI.correoContacto2
            })
        }
        if (clientesFromAPI.nombreContacto3) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto3,
                puestoContacto: clientesFromAPI.puestoContacto3,
                telefonoContacto: clientesFromAPI.telefonoContacto3,
                correoContacto: clientesFromAPI.correoContacto3
            })
        }
        if (clientesFromAPI.nombreContacto4) {
            contactosCliente.push({
                nombreContacto: clientesFromAPI.nombreContacto4,
                puestoContacto: clientesFromAPI.puestoContacto4,
                telefonoContacto: clientesFromAPI.telefonoContacto4,
                correoContacto: clientesFromAPI.correoContacto4
            })
        }
        if (contactosCliente.length >= 5) {
            const contactos = await GetClienteContactos({ clienteID: { eq: id } });
            if (contactos.length > 0) {
                contactosCliente = [...contactosCliente, ...contactos]

            }
        }
        setContactosClientes(contactosCliente);
        setCargando(false);
        return clientesFromAPI;
    }

    //Guarda los datos de los clientes
    async function createClientes() {
        setAVisible(false);
        setCargando(true);
        setGuardarDisabled(true);
        window.scrollTo(0, 0);
        const resultado = await guardarCliente(formData, imagenRepetida, imagen, false);
        setMensajeAlert(resultado.mensaje);
        setColor(resultado.color);
        setCargando(false);
        setAVisible(true);
        setGuardarDisabled(resultado.deshabilitarBoton);
        if (resultado.completo === true) {
            setEstadoCliente("todos");
            setClientes([...clientes, formData]);
            updateFormData(initialFormState);
            updateFormState(() => ({ ...formState, formType: "Catálogo" }));
        }
    }
    function nuevoContacto() {
        setContacto(contacto + 1);
        if (contacto >= 4)
            setisDisabled(true);
    }

    //actualiza  los datos de los clientes
    async function updateClientes() {
        window.scrollTo(0, 0);
        setAVisible(false);
        setCargando(true);
        setGuardarDisabled(true);
        const actualizarCliente = await actualizarClientes(formData, editarImagen, imagen, mClientes, false);
        setMensajeAlert(actualizarCliente.mensaje);
        setColor(actualizarCliente.color);
        setGuardarDisabled(actualizarCliente.deshabilitarBoton);
        setCargando(false);
        setAVisible(true);
        if (actualizarCliente.error === true) {
            setEditarImagen(false);
        }
        if (actualizarCliente.completo === true) {
            setEditarImagen(false);
            setEstadoCliente("todos");
            setClientes([...clientes, formData]);
            updateFormData(initialFormState);
            fetchClientes();
            updateFormState(() => ({ ...formState, formType: "Catálogo" }));
        }
    }

    //Envía al formulario para crear un nuevo cliente
    async function nuevoCliente() {
        await fetchClientesCotizacion();
        setContacto(1);
        setisDisabled(false);
        setCargando(false);
        setAVisible(false);
        setImagenRepetida(false);
        setGuardarDisabled(false);
        updateFormData({ ...formData, Reg_Ins_Usuario: userName });
        updateFormState(() => ({ ...formState, formType: "Nuevo cliente" }));
    }
    //Envía al formulario de Catálogo
    function catalogo() {
        updateFormData(initialFormState);
        setCargando(false);
        setAVisible(false);
        setEstadoCliente("todos");
        updateFormState(() => ({ ...formState, formType: "Catálogo" }));
    }
    //Envía al formulario de Editar Cliente
    function editarCliente() {
        setCargando(false);
        setAVisible(false);
        setGuardarDisabled(false);
        updateFormData({ ...formData, Reg_Mod_Usuario: userName });
        updateFormState(() => ({ ...formState, formType: "Editar Cliente" }));
    }
    return {
        pclientes,
        formType,
        mensajeAlert,
        color,
        aVisible,
        cargando,
        formData,
        clientes,
        estadoCliente,
        inputElement,
        isDisabled,
        contacto,
        guardarDisable,
        editarImagen,
        modal,
        clientesCotizacion,
        contactosClientes,
        setClientesCotizacion,
        seleccionarCliente,
        toggle,
        onDismiss,
        catalogo,
        nuevoCliente,
        fetchClientes,
        sClienteEstado,
        onClickCliente,
        editarCliente,
        onChanges,
        onChangeimage,
        nuevoContacto,
        createClientes,
        updateClientes
    }
}